<template>
  <div class="row mb-1">
    <div id="grafik-tren" class="col-md-12 px-gap">
      <div class="card card-default shade mt-2">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Tren Media Konvensional</h4>
                <p class="small hint-text">Grafik Tren Media Konvensional</p>
              </div>
              <div class="pull-right">
                <div class="form-check form-check-inline switch m-t-20 m-b-0">
                  <input
                    type="checkbox"
                    v-model="show_grafik"
                    id="pagesSwitch"
                  />
                  <label for="pagesSwitch">Tampilkan Grafik Pie dan Bar</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 col-sm-2">
              <loader-component style="margin: auto" v-if="is_loading" />
              <div v-else>
                <div
                  v-if="Object.keys(data.stats).length == 0"
                  class="alert alert-danger"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong> Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div v-else>
                  <div v-if="!show_grafik">
                    <div
                      v-if="
                        this.activeChannel &&
                          this.activeChannel.formed.cetak_status == 1
                      "
                      class="analytic-card"
                    >
                      <p>MEDIA CETAK</p>
                      <h4 style="color: #6c757d !important">
                        <i class="bi bi-newspaper"></i>
                        {{
                          data === null || Object.keys(data.stats).length == 0
                            ? "0"
                            : data.stats.media_cetak | thousandSeparator
                        }}
                      </h4>
                    </div>
                    <div
                      v-if="
                        this.activeChannel &&
                          this.activeChannel.formed.tv_status == 1
                      "
                      class="analytic-card"
                    >
                      <p>MEDIA TV</p>
                      <h4 style="color: #e83e8c !important">
                        <i class="bi bi-tv"></i>
                        {{
                          data === null || Object.keys(data.stats).length == 0
                            ? "0"
                            : data.stats.media_tv | thousandSeparator
                        }}
                      </h4>
                    </div>
                    <div
                      v-if="
                        this.activeChannel &&
                          this.activeChannel.google.news_status == 1
                      "
                      class="analytic-card"
                    >
                      <p>ONLINE NEWS</p>
                      <h4 style="color: #28a745 !important">
                        <i class="bi bi-globe-americas"></i>
                        {{
                          data === null || Object.keys(data.stats).length == 0
                            ? "0"
                            : data.stats.news | thousandSeparator
                        }}
                      </h4>
                    </div>
                  </div>
                  <div v-else>
                    <pie-chart-component
                      :data="data_pie"
                      :config="config_pie"
                      :height="350"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-10 col-sm-10">
              <loader-component v-if="is_loading" />
              <div v-else>
                <div
                  v-if="Object.keys(data.grafik).length == 0"
                  class="alert alert-danger"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div v-else>
                  <line-chart-component
                    v-if="!show_grafik"
                    :series="data.grafik"
                    el="linechart-tren-formed"
                    mode="dual"
                  />
                  <dynamic-chart-component
                    v-else
                    :config="configTren"
                    chart_id="garfik-media-cetak-tren"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import line_chart from "@/views/components/chart/line_chart.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import loader from "@/views/components/loader.vue";
import dynamic_chart from "@/views/components/chart/dynamic_chart.vue";
export default {
  name: "DataTrenFormed",
  components: {
    "line-chart-component": line_chart,
    "pie-chart-component": pie_chart,
    "loader-component": loader,
    "dynamic-chart-component": dynamic_chart,
  },
  data() {
    return {
      show_grafik: false,
      configTren: null,
      data_pie: [],
      config_pie: {
        align: "center",
      },
    };
  },
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return null;
      },
    },
    databar: {
      type: Object,
      default: function() {
        return null;
      },
    },
    activeChannel: {
      type: Object,
      default: function() {
        return null;
      },
    },
  },
  methods: {
    assemblePieChart() {
      if (Object.keys(this.data.stats).length > 0) {
        this.data_pie = [];

        if (this.activeChannel && this.activeChannel.formed.cetak_status == 1) {
          this.data_pie.push({
            color: "#6c757d",
            name: "Media Cetak",
            y: parseInt(this.data.stats.media_cetak),
          });
        }

        if (this.activeChannel && this.activeChannel.formed.tv_status == 1) {
          this.data_pie.push({
            color: "#e83e8c",
            name: "Media TV",
            y: parseInt(this.data.stats.media_tv),
          });
        }

        if (this.activeChannel && this.activeChannel.google.news_status == 1) {
          this.data_pie.push({
            color: "#28a745",
            name: "Online News",
            y: parseInt(this.data.stats.news),
          });
        }
      }
    },
    setData() {
      if (this.data) {
        this.assemblePieChart();
      }
      if (this.databar) {
        this.configTren = {
          chart: {
            type: "column",
            backgroundColor: "transparent",
          },
          credits: {
            enabled: false,
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: this.data.grafik.x,
          },
          yAxis: {
            title: {
              text: "Berita",
            },
            min: 0,
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: "bold",
              },
            },
          },
          legend: {
            align: "center",
          },
          tooltip: {
            headerFormat: "<b>{point.x}</b><br/>",
            pointFormat:
              "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
          },
          plotOptions: {
            column: {
              stacking: "normal",
              dataLabels: {
                enabled: true,
              },
            },
          },
          series: this.data.grafik.y,
        };
      }
    },
  },
  created: function() {
    this.setData();
  },
  watch: {
    data() {
      this.setData();
    },
  },
};
</script>

<style scoped>
.analytic-card {
  padding: 5px 20px;
}
</style>
